import { useRef, useState } from "react";
import { Camera, SpinnerGap, X } from "@phosphor-icons/react";
import api, { fileUrl, formatApiError } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function PhotoUploader({ photos, onChange, testidPrefix = "photo" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, 5 - photos.length);
    e.target.value = "";
    if (!files.length) return;
    setUploading(true);
    const next = [...photos];
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/uploads", fd);
        next.push(data.path);
      } catch (err) {
        toast.error(formatApiError(err));
      }
    }
    onChange(next);
    setUploading(false);
  };

  return (
    <div data-testid={`${testidPrefix}-uploader`}>
      <p className="mb-2 text-sm font-semibold">
        Photos <span className="font-normal text-muted-foreground">(optionnel · {photos.length}/5)</span>
      </p>
      <div className="flex flex-wrap gap-3">
        {photos.map((p, i) => (
          <div key={p} className="relative h-20 w-20 overflow-hidden rounded-2xl border border-black/5">
            <img src={fileUrl(p)} alt={`Photo ${i + 1}`} className="h-full w-full object-cover" />
            <button
              type="button"
              data-testid={`${testidPrefix}-remove-${i}`}
              aria-label="Retirer la photo"
              onClick={() => onChange(photos.filter((x) => x !== p))}
              className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-black/60 text-white transition-colors hover:bg-black/80"
            >
              <X size={12} weight="bold" />
            </button>
          </div>
        ))}
        {photos.length < 5 && (
          <button
            type="button"
            data-testid={`${testidPrefix}-add-button`}
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="flex h-20 w-20 flex-col items-center justify-center gap-1 rounded-2xl border border-dashed border-black/15 bg-white text-muted-foreground transition-colors duration-200 hover:border-primary hover:text-primary"
          >
            {uploading ? <SpinnerGap size={20} className="animate-spin" /> : <Camera size={22} weight="duotone" />}
            <span className="text-[10px] font-semibold">Ajouter</span>
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        hidden
        data-testid={`${testidPrefix}-input`}
        onChange={handleFiles}
      />
    </div>
  );
}
